import { Controller } from "@hotwired/stimulus";
import { validateFields, getNextMemoryId, toggleFileInputVisibility } from "./memory_utilities";
import {
  getActiveCarouselImage,
  removeCarouselImage,
} from "./image_mutations";

export default class extends Controller {
  static targets = [
    "form",
    "carousel",
    "fileInputField",
    "deleteImageForm",
    "nextMemory",
    "finishForm",
  ];

  connect() {
    this.photoExists = this.formTarget.dataset.photoExists == "true";
    validateFields(this.formTarget, this.photoExists);
    this.addEventListeners();

    if (this.hasCarouselTarget) {
      toggleFileInputVisibility(this.fileInputFieldTarget);
    }

    if (this.hasNextMemoryTarget) {
      this.nextMemoryTarget.value = getNextMemoryId() || "";
    }
  }

  addEventListeners() {
    document.addEventListener("file_upload:change", this.handleFileUpload.bind(this));
    this.formTarget.addEventListener("input", this.handleInputChange.bind(this));
  }

  handleFileUpload(_event) {
    validateFields(this.formTarget, this.photoExists);
  }

  handleInputChange(_event) {
    validateFields(this.formTarget, this.photoExists);
  }

  skip() {
    const nextMemory = this.nextMemoryTarget.value;

    if (nextMemory) {
      window.location.href = `${this.formTarget.dataset.redirectUrl}?selectedMemory=${nextMemory}`;
    } else {
      this.finishFormTarget.requestSubmit();
    }
  }

  previous() {
    window.history.back();
  }

  removeFile(event) {
    event.preventDefault();

    const carousel = this.carouselTarget.querySelector("[data-hs-carousel]");
    const imageToRemove = carousel && getActiveCarouselImage(carousel);

    if (!imageToRemove) {
      return;
    }

    this.removeButton = event.currentTarget;
    this.removeButton.disabled = true;

    this.imageToRemoveId = imageToRemove.id;
    this.deleteImageFormTarget.action = `${this.deleteImageFormTarget.dataset.url}/${this.imageToRemoveId}`;
    this.deleteImageFormTarget.requestSubmit();
  }

  fileRemoved(event) {
    this.removeButton.disabled = false;

    if (!event.detail.success) {
      return;
    }

    const carousel = this.carouselTarget.querySelector("[data-hs-carousel]");
    const remainingImages = removeCarouselImage(carousel, this.imageToRemoveId);

    if (remainingImages === 0) {
      this.photoExists = false;
      this.toggleFileInput();
    }
  }

  toggleFileInput() {
    const fileInput = this.fileInputFieldTarget.querySelector("input[type='file']");
    this.fileInputFieldTarget.classList.remove("hidden");
    fileInput.setAttribute("name", "tribute_memory[append_memory_attachments][]");
    this.carouselTarget.classList.add("hidden");
  }
}
